module.exports = __webpack_public_path__ + "img/2011_S.902367d9.png";